import {
    AnimationBaseController,
    GameRandom,
    IAnimationControllerConfiguration,
    Inject
} from "@denishussar/html5-game-engine";
import {FoodController, IFoodControllerOptions} from "./FoodController";
import {DinnerLogic} from "../Logic/DinnerLogic";
import {DinnerModel} from "../Models/DinnerModel";
import {AnimationContents} from "../../../../../../AnimationContents";

export interface IGameScreenControllerOptions {
    onComplete: () => void;
}

export class GameScreenController extends AnimationBaseController {
    $model: DinnerModel;

    private _width: number = 0;
    private _height: number = 0;

    private _screenWidth: number = 0;
    private _screenHeight: number = 0;
    private _screenScale: number = 1;

    public constructor(@Inject private _options: IGameScreenControllerOptions,
                       @Inject private _gameLogic: DinnerLogic,
                       @Inject private _random: GameRandom) {
        super("GameScreenController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return {
            animationContent: AnimationContents.DINNER_JSON,
            libraryName: "mini_game_dinner_container",
            childControllers: {
                coffee: {
                    view: FoodController,
                    instanceName: "mini_game_dinner.coffee",
                    options: <IFoodControllerOptions>{
                        name: "coffee"
                    },
                    model: this.$model.coffee
                },
                sandwich: {
                    view: FoodController,
                    instanceName: "mini_game_dinner.sandwich",
                    options: <IFoodControllerOptions>{
                        name: "sandwich"
                    },
                    model: this.$model.sandwich
                }
            },
            modelEvents: {
                "win": () => {
                    this.$queue.get("win").addToQueue(1);
                }
            },
            queue: {
                "win": {
                    condition: clock => clock > 0.2,
                    action: () => {
                        if (this._options.onComplete) {
                            this._options.onComplete();
                        }
                    }
                },
            }
        };
    }

    protected onInitialize(): void {
        this._width = this.display.width;
        this._height = this.display.height;
    }

    protected onResize(width: number, height: number, scale: number) {
        this._screenWidth = width;
        this._screenHeight = height;
        this._screenScale = scale;

        this.updateScale();
    }

    protected onLandscape(): void {
        this.updateScale();
    }

    protected onPortrait(): void {
        this.updateScale();
    }

    private updateScale(): void {
        this.display.scale.set(Math.min(this._screenWidth / this._width / this._screenScale, this._screenHeight / this._height / this._screenScale));
    }
}
